module.exports = __webpack_public_path__ + "media/brands/land rover-4a0bb03e.png";